

// IMAGE SKELETON
export const ImageSkeleton = ({ width = "100%", height = "200px", borderRadius = "8px" }) => {
  return <div className="skeleton skeleton-image" style={{ width, height, borderRadius }} />;
};

// LINE SKELETON (for text lines)
export const LineSkeleton = ({ width = "100%", height = "16px", borderRadius = "4px", margin = "6px 0" }) => {
  return <div className="skeleton skeleton-line" style={{ width, height, borderRadius, margin }} />;
};

// CIRCLE SKELETON (like avatars)
export const CircleSkeleton = ({ size = "40px" }) => {
  return <div className="skeleton skeleton-circle" style={{ width: size, height: size, borderRadius: "50%" }} />;
};


export const BoxSkeleton = ({ width = "100%", height = "100px", borderRadius = "8px" }) => (
  <div className="ds_box_area skeleton-box" style={{ width, height, borderRadius }}>
    <div className="skeleton skeleton-title"></div>
    <div className="skeleton skeleton-text"></div>
    <div className="skeleton skeleton-text"></div>
  </div>
);

export const BookingSkeleton = ({ width = "100%", height = "100px", borderRadius = "8px" }) => (
  <div className="main_listst skeleton-list" style={{ width, height, borderRadius }}>
    <div className="skeleton skeleton-title" style={{ width: "60%" }}></div>
    <div className="skeleton skeleton-text" style={{ width: "40%" }}></div>
    <div className="skeleton skeleton-text" style={{ width: "40%" }}></div>
  </div>
);

export const SkeletonNotification = () => (
  
  <div className="nt_listing flex items-center space-x-4 mb-4 animate-pulse">
    {/* Bell Icon Skeleton */}
    <div className="mg_icons">
      <div className="w-6 h-6 bg-gray-300 rounded-full"></div>
    </div>

    {/* Message + Date Skeleton */}
    <div className="red_contct  skeleton-text">
      <div className="skeleton-text"></div>
      <div className="h-2 bg-gray-200 rounded w-1/4"></div>       {/* date placeholder */}
    </div>
  </div>
);